// extracted by mini-css-extract-plugin
module.exports = {"voting":"Voting_voting__38xip","voting__title":"Voting_voting__title__3zihF","voting__search":"Voting_voting__search__2bfUy","pagination":"Voting_pagination___FZQ2"};